
import { Component, Prop, Vue, Watch } from 'vue-property-decorator'

@Component
export default class DrawerCard extends Vue {
	readonly threshold: number = 40
	readonly offsetBottom: number = 56
	readonly handleHeight: number = 24
	readonly searchBarHeight: number = 96

	@Prop({ required: false, default: false })
	value!: boolean

	enableScrolling: boolean = false
	animate: boolean = false
	distanceTravelled: number = 0
	prevTouchY: number = 0
	maxHeight: number = 0

	@Prop({ default: null })
	minHeight!: number | null

	elementHeight: number = 0
	originalElementHeight: number = 0

	created() {
		if (this.minHeight) {
			this.elementHeight = this.minHeight
		}
	}

	cardClicked(e) {
		if (e.layerY <= this.handleHeight || !this.value) {
			this.$emit('input', true)
		}
	}

	touchStart(e) {
		if (e.changedTouches.length > 0) {
			this.startMovingCard(e.changedTouches[0].clientY)
		}
	}

	touchMove(e) {
		if (e.changedTouches.length > 0) {
			this.moveCard(e.changedTouches[0].clientY)
		}
	}

	touchEnd(e) {
		if (e.changedTouches.length > 0) {
			this.stopMovingCard(e.changedTouches[0].clientY)
		}
	}

	startMovingCard(y: number) {
		this.distanceTravelled = 0
		this.originalElementHeight = this.elementHeight

		// @ts-ignore
		document.querySelector('body')!.style.overscrollBehavior = 'contain'
		// @ts-ignore
		document.querySelector('html')!.style.overscrollBehavior = 'contain'
		this.prevTouchY = y
		this.animate = false
		this.calculateMaxHeight()
	}

	calculateMaxHeight() {
		const el = this.$refs.aboveFold as Element
		const maxScreenHeight =
			window.innerHeight - (el.getBoundingClientRect().height + this.offsetBottom * 2 + this.searchBarHeight)

		const belowFoldEl = this.$refs.belowFold as Element
		let childrenHeight = 0
		belowFoldEl.childNodes.forEach((node) => {
			const castedNode = node as Element
			childrenHeight += castedNode.getBoundingClientRect().height
		})

		this.maxHeight = Math.min(maxScreenHeight, childrenHeight)
	}

	moveCard(y: number) {
		const currentTouchY = y
		const dY = currentTouchY - this.prevTouchY

		if (this.enableScrolling && this.$el.scrollTop !== 0) {
			this.prevTouchY = currentTouchY
			return
		}
		if (this.$el.scrollTop === 0) {
			this.elementHeight -= currentTouchY - this.prevTouchY

			if (this.elementHeight > this.maxHeight) {
				this.elementHeight = this.maxHeight
			} else if (this.handleHeight && this.elementHeight < this.handleHeight) {
				this.elementHeight = this.handleHeight
			} else if (this.elementHeight < 0) {
				this.elementHeight = 0
			}

			this.distanceTravelled += dY

			if (this.distanceTravelled > 0 && this.$el.getBoundingClientRect().height < window.innerHeight) {
				this.enableScrolling = false
			}
		}
		this.prevTouchY = y
	}

	stopMovingCard(y: number) {
		// @ts-ignore
		document.querySelector('body')!.style.overscrollBehavior = null
		// @ts-ignore
		document.querySelector('html')!.style.overscrollBehavior = null
		if (!this.enableScrolling) {
			this.distanceTravelled += y - this.prevTouchY

			if (this.distanceTravelled > this.threshold && this.minHeight && this.elementHeight < this.minHeight) {
				this.$emit('input', false)
				this.enableScrolling = false
			} else if (this.distanceTravelled > this.threshold) {
				this.elementHeight = this.minHeight || 0
				this.enableScrolling = false
			} else if (this.distanceTravelled < -this.threshold) {
				this.$emit('input', true)
				this.elementHeight = this.maxHeight
				this.enableScrolling = true
			} else {
				this.elementHeight = this.originalElementHeight
				this.enableScrolling = this.value
			}

			this.animate = true
		}
	}

	closeCard() {
		this.elementHeight = this.minHeight || 0
		this.animate = true
		this.enableScrolling = false
	}

	openCard() {
		this.calculateMaxHeight()
		this.elementHeight = this.maxHeight
		this.enableScrolling = true
		this.animate = true
	}

	@Watch('value')
	updateCardState(shouldOpen: boolean) {
		if (shouldOpen) {
			this.openCard()
		} else {
			this.closeCard()
		}
	}

	get styleHeight(): string {
		const convertedHeight = (this.elementHeight / window.innerHeight) * 100

		return `${convertedHeight}vh`
	}
}
